// src/components/Inbox.js
import React, { useState, useEffect , useCallback } from 'react';

import RequirementCard from '../../components/UserInbox/RequirementCard';
import FilterBar from '../../components/UserInbox/FilterBar';
import EmptyState from '../../components/UserInbox/EmptyState';
import Notification from '../../components/UserInbox/Notification';
import Pagination from '../../components/UserInbox/Pagination';
import MobilePagination from '../../components/UserInbox/MobilePagination';
import { fetchUser } from '../../utils/fetchUser';
import {getTicketsUserInbox} from "../../services/Tikets";
import { getCarpetaById } from '../../services/Carpetas';
import { useTicketsMutations } from '../../hooks';
import { useStateContext } from '../../contexts/ContextProvider';
import { NuevoTicketsLF, NuevaCarpeta } from '../../components';

const UserInbox = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const [requirements, setRequirements] = useState([]);
  const [filteredRequirements, setFilteredRequirements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(null);
  const userInfo = fetchUser();
  const [filters, setFilters] = useState({
    tipo: 'ALL',
    estado: 'Pendiente',
    search: '',
    numTicket: '',
    codigoEquipo: ''
  });

  
  const [viewMode, setViewMode] = useState('infinite'); // 'pagination' o 'infinite'
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { updateTicketAsignadoC } = useTicketsMutations();

  const [laSucursal, setLaSucursal] = useState("");
  const [carpetaSeleccionada, setCarpetaSeleccionada] = useState(null);

  const handleVerCarpeta = async (idCarpeta) => {
    try {
      const carpeta = await getCarpetaById(idCarpeta);
      setCarpetaSeleccionada(carpeta);
      handleClick('nuevaCarpeta');
    } catch {
      setNotification({ type: 'error', message: 'No se pudo cargar la carpeta' });
    }
  };

    const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getTicketsUserInbox(userInfo.rol, filters.estado, filters.numTicket, filters.codigoEquipo);
      setRequirements(response);
      setFilteredRequirements(response);
    } catch (err) {
      setNotification({ type: 'error', message: 'Error cargando requerimientos' });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {

    fetchData();
  }, [filters.tipo, filters.estado, filters.numTicket, filters.codigoEquipo]);

  // Cambiar entre modos de visualización
  const toggleViewMode = () => {
    setViewMode(prev => prev === 'pagination' ? 'infinite' : 'pagination');
    setCurrentPage(1);
  };

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleAction = async (upReq, action) => {
    // Simular acción en el requerimiento
    //const upReq = requirements.filter((req) => req._id === id);
 
    if (action === 'approve') {
      const updatedReq = { _id: upReq._id, idAsignado: userInfo.usuario, estado: 'Pendiente' };
      // console.log('Asignar requerimiento:', updatedReq);
      await updateTicketAsignadoC.mutateAsync( updatedReq );
      fetchData();
    }
    else if (action === 'edit') {
      //newStatus = 'rejected';
      setLaSucursal(upReq);
      handleClick('nuevoTicket');
    }
    else if (action === 'cancel') {
      const updatedReq = { _id: upReq._id, idAsignado: userInfo.usuario, estado: 'Cancelado' };
      // console.log('Asignar requerimiento:', updatedReq);
      await updateTicketAsignadoC.mutateAsync( updatedReq );
      fetchData();
    }
        
    // setRequirements(updatedRequirements);
    
      // Mostrar notificación
      setNotification({
        type: 'success',
        message: `Requerimiento ${action === 'delete' ? 'eliminado' : 'actualizado'} correctamente`
      });
    
    // Ocultar notificación después de 3 segundos
    setTimeout(() => setNotification(null), 3000);
  };

  const handleDelete = (id) => {
    if (window.confirm('¿Estás seguro de eliminar este requerimiento?')) {
      const updatedRequirements = requirements.filter(req => req.id !== id);
      setRequirements(updatedRequirements);
      
      setNotification({
        type: 'success',
        message: 'Requerimiento eliminado correctamente'
      });
      
      setTimeout(() => setNotification(null), 3000);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }


  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      fetchData();
    }

  };


  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 mt-12">

      <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Notificaciones
              </p>
            </div>
        <div className="mt-4 md:mt-0 text-sm text-gray-600">
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
            Rol: {userInfo.rol}
          </span>
        </div>
      </div>

      
      <FilterBar 
        filters={filters} 
        onFilterChange={handleFilterChange} 
        userRole={userInfo.rol}
      />
      
      <div className="flex justify-between items-center mb-4">
        <div className="text-sm text-gray-600">
          {viewMode === 'pagination' ? (
            <span>Modo paginación ({currentPage}/{totalPages})</span>
          ) : (
            <span>Modo scroll infinito</span>
          )}
        </div>
        <button
          onClick={toggleViewMode}
          className="text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded-md transition-colors"
        >
          Cambiar a {viewMode === 'pagination' ? 'Scroll Infinito' : 'Paginación'}
        </button>
      </div>

      {notification && (
        <Notification 
          type={notification.type} 
          message={notification.message} 
          onClose={() => setNotification(null)} 
        />
      )}
      
      {filteredRequirements && filteredRequirements.length === 0 ? (
        <EmptyState filters={filters} />
      ) : (
        <div className="grid grid-cols-1 gap-4 mt-6">
          {filteredRequirements.map(req => (
            <RequirementCard
              key={req.id}
              requirement={req}
              onAction={handleAction}
              onDelete={handleDelete}
              onVerCarpeta={handleVerCarpeta}
            />
          ))}
        </div>
      )}

      {viewMode === 'pagination' && (
      <>
        <div className="hidden sm:block">
          <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
        <div className="sm:hidden">
          <MobilePagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </>
    )}
    {isClicked.nuevoTicket && (<NuevoTicketsLF vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
    {isClicked.nuevaCarpeta && carpetaSeleccionada && (<NuevaCarpeta vecinoData={carpetaSeleccionada} onChangeVecino={handleRefreshDataTable} soloLectura={true}/>)}
    </div>
  );
};

export default UserInbox;